import SmallRedButton from '@components/common/button/SmallRedButton';
import EnumField from '@components/common/form/formik/input/EnumField';
import { TimeZone } from '@data/course/courseData';
import React, { useState } from 'react';
import FoldAnimation from './animation/FoldAnimation';
import DynamicChevron from './icons/DynamicChevron';
import MeetingsInfo from './MeetingsInfo';

interface SectionInfoProps {
  meetingsLength: number;
  sectionIndex: number;
  removeSelf: (index: number) => void | undefined;
  canRemove: boolean;
}

const SectionInfo: React.FC<SectionInfoProps> = ({
  meetingsLength,
  sectionIndex,
  removeSelf,
  canRemove,
}) => {
  const timeZoneLocation = `sections[${sectionIndex}].timeZone`;
  const [folded, setFolded] = useState(false);

  return (
    <>
      <div className='flex flex-row items-center'>
        <p className='text-xl'>Section {sectionIndex + 1}</p>
        <div className='ml-auto'>
          <DynamicChevron onChange={() => setFolded((f) => !f)} folded={folded} />
        </div>
      </div>
      <FoldAnimation folded={folded}>
        <div className='ml-8 mb-4'>
          <EnumField
            label='Time Zone'
            name={timeZoneLocation}
            enumToUse={TimeZone}
            className='w-2/4'
          />
        </div>
        <div className='ml-8'>
          <MeetingsInfo meetingsLength={meetingsLength} sectionIndex={sectionIndex}></MeetingsInfo>
        </div>
        <SmallRedButton
          text='REMOVE SECTION'
          onClick={() => removeSelf(sectionIndex)}
          clickable={canRemove}
        />
      </FoldAnimation>
    </>
  );
};

export default SectionInfo;
